// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Bl-z","tupacHeader":"Cl-z","tupacHeader2":"Dl-z","tupacMenu":"El-z","tupacMenu2":"Fl-z","tupacMain":"Gl-z","tupacMain2":"Hl-z"};